// extracted by mini-css-extract-plugin
module.exports = {"container":"_22PvJQcsxc2kHt8QlZucQc"};